import { ref, onMounted, computed } from 'vue'
import { useSupabaseClient } from '#imports'

export default function useCampaigns() {
  const supabase = useSupabaseClient()
  const campaigns = ref([])
  const loading = ref(true)
  const error = ref(null)
  
  // Check if the user has any campaigns
  const hasCampaigns = computed(() => campaigns.value.length > 0)

  // Fetch all campaigns for the current user
  const fetchCampaigns = async () => {
    loading.value = true
    error.value = null
    
    try {
      // Get campaigns with limit 1 to check existence efficiently
      const { data, error: campaignsError } = await supabase
        .from('campaigns')
        .select('id')
        .limit(1)
      
      if (campaignsError) throw campaignsError
      
      campaigns.value = data || []
    } catch (err) {
      console.error('Error fetching campaigns:', err)
      error.value = 'Failed to load campaigns'
    } finally {
      loading.value = false
    }
  }

  return {
    campaigns,
    loading, 
    error,
    hasCampaigns,
    fetchCampaigns
  }
} 